module.exports = __webpack_public_path__ + "img/高通1.6822226e.png";